import DirectInput from '../../../../components/directInput/DirectInput';

const Percentage = ({ formData, setFormData }) => {
    return (
        <div>
            <h2 className='orgRegisterH2'>Percentage Details</h2>
            <div className='orgRegisterSecDiv'>
                <DirectInput
                    label='TrvTo Website'
                    name={'webCom'}
                    value={formData.webCom}
                    type='number'
                    placeholder='TrvTo website percentage'
                    setFormData={setFormData}
                    min={0}
                    max={100}
                    limit={100}
                />
                <DirectInput
                    label='Organizer Website'
                    name={'orgWeb'}
                    value={formData.orgWeb}
                    type='number'
                    placeholder='organizer website percentage'
                    setFormData={setFormData}
                    min={0}
                    max={100}
                    limit={100}
                />
                <DirectInput
                    label='Others Website'
                    name={'othWeb'}
                    value={formData.othWeb}
                    type='number'
                    placeholder='Others website percentage'
                    setFormData={setFormData}
                    min={0}
                    max={100}
                    limit={100}
                />
            </div>
        </div>
    );
};

export default Percentage;
